require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.sort.js");

require("core-js/modules/es.array.reduce.js");

(function (f) {
  if (typeof exports === "object" && typeof module !== "undefined") {
    module.exports = f();
  } else if (typeof define === "function" && define.amd) {
    define([], f);
  } else {
    var g;

    if (typeof window !== "undefined") {
      g = window;
    } else if (typeof global !== "undefined") {
      g = global;
    } else if (typeof self !== "undefined") {
      g = self;
    } else {
      g = this;
    }

    g.lottie_api = f();
  }
})(function () {
  var define, module, exports;
  return function () {
    function r(e, n, t) {
      function o(i, f) {
        if (!n[i]) {
          if (!e[i]) {
            var c = "function" == typeof require && require;
            if (!f && c) return c(i, !0);
            if (u) return u(i, !0);
            var a = new Error("Cannot find module '" + i + "'");
            throw a.code = "MODULE_NOT_FOUND", a;
          }

          var p = n[i] = {
            exports: {}
          };
          e[i][0].call(p.exports, function (r) {
            var n = e[i][1][r];
            return o(n || r);
          }, p, p.exports, r, e, n, t);
        }

        return n[i].exports;
      }

      for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
        o(t[i]);
      }

      return o;
    }

    return r;
  }()({
    1: [function (require, module, exports) {
      'use strict';

      var Renderer = require('../renderer/Renderer');

      var layer_api = require('../helpers/layerAPIBuilder');

      function AnimationItemFactory(animation) {
        var state = {
          animation: animation,
          elements: animation.renderer.elements.map(function (item) {
            return layer_api(item, animation);
          }),
          boundingRect: null,
          scaleData: null
        };

        function getCurrentFrame() {
          return animation.currentFrame;
        }

        function getCurrentTime() {
          return animation.currentFrame / animation.frameRate;
        }

        function addValueCallback(properties, value) {
          var i,
              len = properties.length;

          for (i = 0; i < len; i += 1) {
            properties.getPropertyAtIndex(i).setValue(value);
          }
        }

        function toKeypathLayerPoint(properties, point) {
          var i,
              len = properties.length;
          var points = [];

          for (i = 0; i < len; i += 1) {
            points.push(properties.getPropertyAtIndex(i).toKeypathLayerPoint(point));
          }

          if (points.length === 1) {
            return points[0];
          }

          return points;
        }

        function fromKeypathLayerPoint(properties, point) {
          var i,
              len = properties.length;
          var points = [];

          for (i = 0; i < len; i += 1) {
            points.push(properties.getPropertyAtIndex(i).fromKeypathLayerPoint(point));
          }

          if (points.length === 1) {
            return points[0];
          }

          return points;
        }

        function calculateScaleData(boundingRect) {
          var compWidth = animation.animationData.w;
          var compHeight = animation.animationData.h;
          var compRel = compWidth / compHeight;
          var elementWidth = boundingRect.width;
          var elementHeight = boundingRect.height;
          var elementRel = elementWidth / elementHeight;
          var scale, scaleXOffset, scaleYOffset;
          var xAlignment, yAlignment, scaleMode;
          var aspectRatio = animation.renderer.renderConfig.preserveAspectRatio.split(' ');

          if (aspectRatio[1] === 'meet') {
            scale = elementRel > compRel ? elementHeight / compHeight : elementWidth / compWidth;
          } else {
            scale = elementRel > compRel ? elementWidth / compWidth : elementHeight / compHeight;
          }

          xAlignment = aspectRatio[0].substr(0, 4);
          yAlignment = aspectRatio[0].substr(4);

          if (xAlignment === 'xMin') {
            scaleXOffset = 0;
          } else if (xAlignment === 'xMid') {
            scaleXOffset = (elementWidth - compWidth * scale) / 2;
          } else {
            scaleXOffset = elementWidth - compWidth * scale;
          }

          if (yAlignment === 'YMin') {
            scaleYOffset = 0;
          } else if (yAlignment === 'YMid') {
            scaleYOffset = (elementHeight - compHeight * scale) / 2;
          } else {
            scaleYOffset = elementHeight - compHeight * scale;
          }

          return {
            scaleYOffset: scaleYOffset,
            scaleXOffset: scaleXOffset,
            scale: scale
          };
        }

        function recalculateSize(container) {
          var container = animation.wrapper;
          state.boundingRect = container.getBoundingClientRect();
          state.scaleData = calculateScaleData(state.boundingRect);
        }

        function toContainerPoint(point) {
          if (!animation.wrapper || !animation.wrapper.getBoundingClientRect) {
            return point;
          }

          if (!state.boundingRect) {
            recalculateSize();
          }

          var boundingRect = state.boundingRect;
          var newPoint = [point[0] - boundingRect.left, point[1] - boundingRect.top];
          var scaleData = state.scaleData;
          newPoint[0] = (newPoint[0] - scaleData.scaleXOffset) / scaleData.scale;
          newPoint[1] = (newPoint[1] - scaleData.scaleYOffset) / scaleData.scale;
          return newPoint;
        }

        function fromContainerPoint(point) {
          if (!animation.wrapper || !animation.wrapper.getBoundingClientRect) {
            return point;
          }

          if (!state.boundingRect) {
            recalculateSize();
          }

          var boundingRect = state.boundingRect;
          var scaleData = state.scaleData;
          var newPoint = [point[0] * scaleData.scale + scaleData.scaleXOffset, point[1] * scaleData.scale + scaleData.scaleYOffset];
          var newPoint = [newPoint[0] + boundingRect.left, newPoint[1] + boundingRect.top];
          return newPoint;
        }

        function getScaleData() {
          return state.scaleData;
        }

        var methods = {
          recalculateSize: recalculateSize,
          getScaleData: getScaleData,
          toContainerPoint: toContainerPoint,
          fromContainerPoint: fromContainerPoint,
          getCurrentFrame: getCurrentFrame,
          getCurrentTime: getCurrentTime,
          addValueCallback: addValueCallback,
          toKeypathLayerPoint: toKeypathLayerPoint,
          fromKeypathLayerPoint: fromKeypathLayerPoint
        };
        return Object.assign({}, Renderer(state), methods);
      }

      module.exports = AnimationItemFactory;
    }, {
      "../helpers/layerAPIBuilder": 6,
      "../renderer/Renderer": 42
    }],
    2: [function (require, module, exports) {
      'use strict';

      module.exports = ',';
    }, {}],
    3: [function (require, module, exports) {
      'use strict';

      module.exports = {
        0: 0,
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        13: 13,
        'comp': 0,
        'composition': 0,
        'solid': 1,
        'image': 2,
        'null': 3,
        'shape': 4,
        'text': 5,
        'camera': 13
      };
    }, {}],
    4: [function (require, module, exports) {
      'use strict';

      module.exports = {
        LAYER_TRANSFORM: 'transform'
      };
    }, {}],
    5: [function (require, module, exports) {
      'use strict';

      var key_path_separator = require('../enums/key_path_separator');

      var sanitizeString = require('./stringSanitizer');

      module.exports = function (propertyPath) {
        var keyPathSplit = propertyPath.split(key_path_separator);
        var selector = keyPathSplit.shift();
        return {
          selector: sanitizeString(selector),
          propertyPath: keyPathSplit.join(key_path_separator)
        };
      };
    }, {
      "../enums/key_path_separator": 2,
      "./stringSanitizer": 7
    }],
    6: [function (require, module, exports) {
      'use strict';

      var TextElement = require('../layer/text/TextElement');

      var ShapeElement = require('../layer/shape/Shape');

      var NullElement = require('../layer/null_element/NullElement');

      var SolidElement = require('../layer/solid/SolidElement');

      var ImageElement = require('../layer/image/ImageElement');

      var CameraElement = require('../layer/camera/Camera');

      var LayerBase = require('../layer/LayerBase');

      module.exports = function getLayerApi(element, parent) {
        var layerType = element.data.ty;

        var Composition = require('../layer/composition/Composition');

        switch (layerType) {
          case 0:
            return Composition(element, parent);

          case 1:
            return SolidElement(element, parent);

          case 2:
            return ImageElement(element, parent);

          case 3:
            return NullElement(element, parent);

          case 4:
            return ShapeElement(element, parent, element.data.shapes, element.itemsData);

          case 5:
            return TextElement(element, parent);

          case 13:
            return CameraElement(element, parent);

          default:
            return LayerBase(element, parent);
        }
      };
    }, {
      "../layer/LayerBase": 13,
      "../layer/camera/Camera": 15,
      "../layer/composition/Composition": 16,
      "../layer/image/ImageElement": 20,
      "../layer/null_element/NullElement": 21,
      "../layer/shape/Shape": 22,
      "../layer/solid/SolidElement": 35,
      "../layer/text/TextElement": 38
    }],
    7: [function (require, module, exports) {
      "use strict";

      function sanitizeString(string) {
        return string.trim();
      }

      module.exports = sanitizeString;
    }, {}],
    8: [function (require, module, exports) {
      'use strict';

      var createTypedArray = require('./typedArrays');
      /*!
       Transformation Matrix v2.0
       (c) Epistemex 2014-2015
       www.epistemex.com
       By Ken Fyrstenberg
       Contributions by leeoniya.
       License: MIT, header required.
       */

      /**
       * 2D transformation matrix object initialized with identity matrix.
       *
       * The matrix can synchronize a canvas context by supplying the context
       * as an argument, or later apply current absolute transform to an
       * existing context.
       *
       * All values are handled as floating point values.
       *
       * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
       * @prop {number} a - scale x
       * @prop {number} b - shear y
       * @prop {number} c - shear x
       * @prop {number} d - scale y
       * @prop {number} e - translate x
       * @prop {number} f - translate y
       * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
       * @constructor
       */


      var Matrix = function () {
        var _cos = Math.cos;
        var _sin = Math.sin;
        var _tan = Math.tan;
        var _rnd = Math.round;

        function reset() {
          this.props[0] = 1;
          this.props[1] = 0;
          this.props[2] = 0;
          this.props[3] = 0;
          this.props[4] = 0;
          this.props[5] = 1;
          this.props[6] = 0;
          this.props[7] = 0;
          this.props[8] = 0;
          this.props[9] = 0;
          this.props[10] = 1;
          this.props[11] = 0;
          this.props[12] = 0;
          this.props[13] = 0;
          this.props[14] = 0;
          this.props[15] = 1;
          return this;
        }

        function rotate(angle) {
          if (angle === 0) {
            return this;
          }

          var mCos = _cos(angle);

          var mSin = _sin(angle);

          return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }

        function rotateX(angle) {
          if (angle === 0) {
            return this;
          }

          var mCos = _cos(angle);

          var mSin = _sin(angle);

          return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
        }

        function rotateY(angle) {
          if (angle === 0) {
            return this;
          }

          var mCos = _cos(angle);

          var mSin = _sin(angle);

          return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
        }

        function rotateZ(angle) {
          if (angle === 0) {
            return this;
          }

          var mCos = _cos(angle);

          var mSin = _sin(angle);

          return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }

        function shear(sx, sy) {
          return this._t(1, sy, sx, 1, 0, 0);
        }

        function skew(ax, ay) {
          return this.shear(_tan(ax), _tan(ay));
        }

        function skewFromAxis(ax, angle) {
          var mCos = _cos(angle);

          var mSin = _sin(angle);

          return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); //return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
        }

        function scale(sx, sy, sz) {
          sz = isNaN(sz) ? 1 : sz;

          if (sx == 1 && sy == 1 && sz == 1) {
            return this;
          }

          return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
        }

        function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
          this.props[0] = a;
          this.props[1] = b;
          this.props[2] = c;
          this.props[3] = d;
          this.props[4] = e;
          this.props[5] = f;
          this.props[6] = g;
          this.props[7] = h;
          this.props[8] = i;
          this.props[9] = j;
          this.props[10] = k;
          this.props[11] = l;
          this.props[12] = m;
          this.props[13] = n;
          this.props[14] = o;
          this.props[15] = p;
          return this;
        }

        function translate(tx, ty, tz) {
          tz = tz || 0;

          if (tx !== 0 || ty !== 0 || tz !== 0) {
            return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
          }

          return this;
        }

        function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
          var _p = this.props;

          if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
            //NOTE: commenting this condition because TurboFan deoptimizes code when present
            //if(m2 !== 0 || n2 !== 0 || o2 !== 0){
            _p[12] = _p[12] * a2 + _p[15] * m2;
            _p[13] = _p[13] * f2 + _p[15] * n2;
            _p[14] = _p[14] * k2 + _p[15] * o2;
            _p[15] = _p[15] * p2; //}

            this._identityCalculated = false;
            return this;
          }

          var a1 = _p[0];
          var b1 = _p[1];
          var c1 = _p[2];
          var d1 = _p[3];
          var e1 = _p[4];
          var f1 = _p[5];
          var g1 = _p[6];
          var h1 = _p[7];
          var i1 = _p[8];
          var j1 = _p[9];
          var k1 = _p[10];
          var l1 = _p[11];
          var m1 = _p[12];
          var n1 = _p[13];
          var o1 = _p[14];
          var p1 = _p[15];
          /* matrix order (canvas compatible):
           * ace
           * bdf
           * 001
           */

          _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
          _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
          _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
          _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
          _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
          _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
          _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
          _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
          _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
          _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
          _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
          _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
          _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
          _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
          _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
          _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
          this._identityCalculated = false;
          return this;
        }

        function isIdentity() {
          if (!this._identityCalculated) {
            this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
            this._identityCalculated = true;
          }

          return this._identity;
        }

        function equals(matr) {
          var i = 0;

          while (i < 16) {
            if (matr.props[i] !== this.props[i]) {
              return false;
            }

            i += 1;
          }

          return true;
        }

        function clone(matr) {
          var i;

          for (i = 0; i < 16; i += 1) {
            matr.props[i] = this.props[i];
          }
        }

        function cloneFromProps(props) {
          var i;

          for (i = 0; i < 16; i += 1) {
            this.props[i] = props[i];
          }
        }

        function applyToPoint(x, y, z) {
          return {
            x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
            y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
            z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
          };
          /*return {
           x: x * me.a + y * me.c + me.e,
           y: x * me.b + y * me.d + me.f
           };*/
        }

        function applyToX(x, y, z) {
          return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
        }

        function applyToY(x, y, z) {
          return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
        }

        function applyToZ(x, y, z) {
          return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
        }

        function inversePoint(pt) {
          var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
          var a = this.props[5] / determinant;
          var b = -this.props[1] / determinant;
          var c = -this.props[4] / determinant;
          var d = this.props[0] / determinant;
          var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
          var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
          return [pt[0] * a + pt[1] * c + e, pt[0] * b + pt[1] * d + f, 0];
        }

        function inversePoints(pts) {
          var i,
              len = pts.length,
              retPts = [];

          for (i = 0; i < len; i += 1) {
            retPts[i] = inversePoint(pts[i]);
          }

          return retPts;
        }

        function applyToTriplePoints(pt1, pt2, pt3) {
          var arr = createTypedArray('float32', 6);

          if (this.isIdentity()) {
            arr[0] = pt1[0];
            arr[1] = pt1[1];
            arr[2] = pt2[0];
            arr[3] = pt2[1];
            arr[4] = pt3[0];
            arr[5] = pt3[1];
          } else {
            var p0 = this.props[0],
                p1 = this.props[1],
                p4 = this.props[4],
                p5 = this.props[5],
                p12 = this.props[12],
                p13 = this.props[13];
            arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
            arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
            arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
            arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
            arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
            arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
          }

          return arr;
        }

        function applyToPointArray(x, y, z) {
          var arr;

          if (this.isIdentity()) {
            arr = [x, y, z];
          } else {
            arr = [x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12], x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13], x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]];
          }

          return arr;
        }

        function applyToPointStringified(x, y) {
          if (this.isIdentity()) {
            return x + ',' + y;
          }

          return x * this.props[0] + y * this.props[4] + this.props[12] + ',' + (x * this.props[1] + y * this.props[5] + this.props[13]);
        }

        function toCSS() {
          //Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.

          /*if(this.isIdentity()) {
              return '';
          }*/
          var i = 0;
          var props = this.props;
          var cssValue = 'matrix3d(';
          var v = 10000;

          while (i < 16) {
            cssValue += _rnd(props[i] * v) / v;
            cssValue += i === 15 ? ')' : ',';
            i += 1;
          }

          return cssValue;
        }

        function to2dCSS() {
          //Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.

          /*if(this.isIdentity()) {
              return '';
          }*/
          var v = 10000;
          var props = this.props;
          return "matrix(" + _rnd(props[0] * v) / v + ',' + _rnd(props[1] * v) / v + ',' + _rnd(props[4] * v) / v + ',' + _rnd(props[5] * v) / v + ',' + _rnd(props[12] * v) / v + ',' + _rnd(props[13] * v) / v + ")";
        }

        function MatrixInstance() {
          this.reset = reset;
          this.rotate = rotate;
          this.rotateX = rotateX;
          this.rotateY = rotateY;
          this.rotateZ = rotateZ;
          this.skew = skew;
          this.skewFromAxis = skewFromAxis;
          this.shear = shear;
          this.scale = scale;
          this.setTransform = setTransform;
          this.translate = translate;
          this.transform = transform;
          this.applyToPoint = applyToPoint;
          this.applyToX = applyToX;
          this.applyToY = applyToY;
          this.applyToZ = applyToZ;
          this.applyToPointArray = applyToPointArray;
          this.applyToTriplePoints = applyToTriplePoints;
          this.applyToPointStringified = applyToPointStringified;
          this.toCSS = toCSS;
          this.to2dCSS = to2dCSS;
          this.clone = clone;
          this.cloneFromProps = cloneFromProps;
          this.equals = equals;
          this.inversePoints = inversePoints;
          this.inversePoint = inversePoint;
          this._t = this.transform;
          this.isIdentity = isIdentity;
          this._identity = true;
          this._identityCalculated = false;
          this.props = createTypedArray('float32', 16);
          this.reset();
        }

        ;
        return function () {
          return new MatrixInstance();
        };
      }();

      module.exports = Matrix;
    }, {
      "./typedArrays": 9
    }],
    9: [function (require, module, exports) {
      'use strict';

      var createTypedArray = function () {
        function createRegularArray(type, len) {
          var i = 0,
              arr = [],
              value;

          switch (type) {
            case 'int16':
            case 'uint8c':
              value = 1;
              break;

            default:
              value = 1.1;
              break;
          }

          for (i = 0; i < len; i += 1) {
            arr.push(value);
          }

          return arr;
        }

        function createTypedArray(type, len) {
          if (type === 'float32') {
            return new Float32Array(len);
          } else if (type === 'int16') {
            return new Int16Array(len);
          } else if (type === 'uint8c') {
            return new Uint8ClampedArray(len);
          }
        }

        if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') {
          return createTypedArray;
        } else {
          return createRegularArray;
        }
      }();

      module.exports = createTypedArray;
    }, {}],
    10: [function (require, module, exports) {
      'use strict';

      var AnimationItem = require('./animation/AnimationItem');

      function createAnimationApi(anim) {
        return Object.assign({}, AnimationItem(anim));
      }

      module.exports = {
        createAnimationApi: createAnimationApi
      };
    }, {
      "./animation/AnimationItem": 1
    }],
    11: [function (require, module, exports) {
      'use strict';

      var keyPathBuilder = require('../helpers/keyPathBuilder');

      var layer_types = require('../enums/layer_types');

      function KeyPathList(elements, node_type) {
        function _getLength() {
          return elements.length;
        }

        function _filterLayerByType(elements, type) {
          return elements.filter(function (element) {
            return element.getTargetLayer().data.ty === layer_types[type];
          });
        }

        function _filterLayerByName(elements, name) {
          return elements.filter(function (element) {
            return element.getTargetLayer().data.nm === name;
          });
        }

        function _filterLayerByProperty(elements, name) {
          return elements.filter(function (element) {
            if (element.hasProperty(name)) {
              return element.getProperty(name);
            }

            return false;
          });
        }

        function getLayersByType(selector) {
          return KeyPathList(_filterLayerByType(elements, selector), 'layer');
        }

        function getLayersByName(selector) {
          return KeyPathList(_filterLayerByName(elements, selector), 'layer');
        }

        function getPropertiesBySelector(selector) {
          return KeyPathList(elements.filter(function (element) {
            return element.hasProperty(selector);
          }).map(function (element) {
            return element.getProperty(selector);
          }), 'property');
        }

        function getLayerProperty(selector) {
          var layers = _filterLayerByProperty(elements, selector);

          var properties = layers.map(function (element) {
            return element.getProperty(selector);
          });
          return KeyPathList(properties, 'property');
        }

        function getKeyPath(propertyPath) {
          var keyPathData = keyPathBuilder(propertyPath);
          var selector = keyPathData.selector;
          var nodesByName, nodesByType, selectedNodes;

          if (node_type === 'renderer' || node_type === 'layer') {
            nodesByName = getLayersByName(selector);
            nodesByType = getLayersByType(selector);

            if (nodesByName.length === 0 && nodesByType.length === 0) {
              selectedNodes = getLayerProperty(selector);
            } else {
              selectedNodes = nodesByName.concat(nodesByType);
            }

            if (keyPathData.propertyPath) {
              return selectedNodes.getKeyPath(keyPathData.propertyPath);
            } else {
              return selectedNodes;
            }
          } else if (node_type === 'property') {
            selectedNodes = getPropertiesBySelector(selector);

            if (keyPathData.propertyPath) {
              return selectedNodes.getKeyPath(keyPathData.propertyPath);
            } else {
              return selectedNodes;
            }
          }
        }

        function concat(nodes) {
          var nodesElements = nodes.getElements();
          return KeyPathList(elements.concat(nodesElements), node_type);
        }

        function getElements() {
          return elements;
        }

        function getPropertyAtIndex(index) {
          return elements[index];
        }

        var methods = {
          getKeyPath: getKeyPath,
          concat: concat,
          getElements: getElements,
          getPropertyAtIndex: getPropertyAtIndex
        };
        Object.defineProperty(methods, 'length', {
          get: _getLength
        });
        return methods;
      }

      module.exports = KeyPathList;
    }, {
      "../enums/layer_types": 3,
      "../helpers/keyPathBuilder": 5
    }],
    12: [function (require, module, exports) {
      'use strict';

      var key_path_separator = require('../enums/key_path_separator');

      var property_names = require('../enums/property_names');

      function KeyPathNode(state) {
        function getPropertyByPath(selector, propertyPath) {
          var instanceProperties = state.properties || [];
          var i = 0,
              len = instanceProperties.length;

          while (i < len) {
            if (instanceProperties[i].name === selector) {
              return instanceProperties[i].value;
            }

            i += 1;
          }

          return null;
        }

        function hasProperty(selector) {
          return !!getPropertyByPath(selector);
        }

        function getProperty(selector) {
          return getPropertyByPath(selector);
        }

        function fromKeypathLayerPoint(point) {
          return state.parent.fromKeypathLayerPoint(point);
        }

        function toKeypathLayerPoint(point) {
          return state.parent.toKeypathLayerPoint(point);
        }

        var methods = {
          hasProperty: hasProperty,
          getProperty: getProperty,
          fromKeypathLayerPoint: fromKeypathLayerPoint,
          toKeypathLayerPoint: toKeypathLayerPoint
        };
        return methods;
      }

      module.exports = KeyPathNode;
    }, {
      "../enums/key_path_separator": 2,
      "../enums/property_names": 4
    }],
    13: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../key_path/KeyPathNode');

      var Transform = require('./transform/Transform');

      var Effects = require('./effects/Effects');

      var Matrix = require('../helpers/transformationMatrix');

      function LayerBase(state) {
        var transform = Transform(state.element.finalTransform.mProp, state);
        var effects = Effects(state.element.effectsManager.effectElements || [], state);

        function _buildPropertyMap() {
          state.properties.push({
            name: 'transform',
            value: transform
          }, {
            name: 'Transform',
            value: transform
          }, {
            name: 'Effects',
            value: effects
          }, {
            name: 'effects',
            value: effects
          });
        }

        function getElementToPoint(point) {}

        function toKeypathLayerPoint(point) {
          var element = state.element;

          if (state.parent.toKeypathLayerPoint) {
            point = state.parent.toKeypathLayerPoint(point);
          }

          var toWorldMat = Matrix();
          var transformMat = state.getProperty('Transform').getTargetTransform();
          transformMat.applyToMatrix(toWorldMat);

          if (element.hierarchy && element.hierarchy.length) {
            var i,
                len = element.hierarchy.length;

            for (i = 0; i < len; i += 1) {
              element.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
            }
          }

          return toWorldMat.inversePoint(point);
        }

        function fromKeypathLayerPoint(point) {
          var element = state.element;
          var toWorldMat = Matrix();
          var transformMat = state.getProperty('Transform').getTargetTransform();
          transformMat.applyToMatrix(toWorldMat);

          if (element.hierarchy && element.hierarchy.length) {
            var i,
                len = element.hierarchy.length;

            for (i = 0; i < len; i += 1) {
              element.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
            }
          }

          point = toWorldMat.applyToPointArray(point[0], point[1], point[2] || 0);

          if (state.parent.fromKeypathLayerPoint) {
            return state.parent.fromKeypathLayerPoint(point);
          } else {
            return point;
          }
        }

        function getTargetLayer() {
          return state.element;
        }

        var methods = {
          getTargetLayer: getTargetLayer,
          toKeypathLayerPoint: toKeypathLayerPoint,
          fromKeypathLayerPoint: fromKeypathLayerPoint
        };

        _buildPropertyMap();

        return Object.assign(state, KeyPathNode(state), methods);
      }

      module.exports = LayerBase;
    }, {
      "../helpers/transformationMatrix": 8,
      "../key_path/KeyPathNode": 12,
      "./effects/Effects": 19,
      "./transform/Transform": 39
    }],
    14: [function (require, module, exports) {
      'use strict';

      var layer_types = require('../enums/layer_types');

      var layer_api = require('../helpers/layerAPIBuilder');

      function LayerList(elements) {
        function _getLength() {
          return elements.length;
        }

        function _filterLayerByType(elements, type) {
          return elements.filter(function (element) {
            return element.data.ty === layer_types[type];
          });
        }

        function _filterLayerByName(elements, name) {
          return elements.filter(function (element) {
            return element.data.nm === name;
          });
        }

        function getLayers() {
          return LayerList(elements);
        }

        function getLayersByType(type) {
          var elementsList = _filterLayerByType(elements, type);

          return LayerList(elementsList);
        }

        function getLayersByName(type) {
          var elementsList = _filterLayerByName(elements, type);

          return LayerList(elementsList);
        }

        function layer(index) {
          if (index >= elements.length) {
            return [];
          }

          return layer_api(elements[parseInt(index)]);
        }

        function addIteratableMethods(iteratableMethods, list) {
          iteratableMethods.reduce(function (accumulator, value) {
            var _value = value;

            accumulator[value] = function () {
              var _arguments = arguments;
              return elements.map(function (element) {
                var layer = layer_api(element);

                if (layer[_value]) {
                  return layer[_value].apply(null, _arguments);
                }

                return null;
              });
            };

            return accumulator;
          }, methods);
        }

        function getTargetElements() {
          return elements;
        }

        function concat(list) {
          return elements.concat(list.getTargetElements());
        }

        var methods = {
          getLayers: getLayers,
          getLayersByType: getLayersByType,
          getLayersByName: getLayersByName,
          layer: layer,
          concat: concat,
          getTargetElements: getTargetElements
        };
        addIteratableMethods(['setTranslate', 'getType', 'getDuration']);
        addIteratableMethods(['setText', 'getText', 'setDocumentData', 'canResizeFont', 'setMinimumFontSize']);
        Object.defineProperty(methods, 'length', {
          get: _getLength
        });
        return methods;
      }

      module.exports = LayerList;
    }, {
      "../enums/layer_types": 3,
      "../helpers/layerAPIBuilder": 6
    }],
    15: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../../key_path/KeyPathNode');

      var Property = require('../../property/Property');

      function Camera(element, parent) {
        var instance = {};
        var state = {
          element: element,
          parent: parent,
          properties: _buildPropertyMap()
        };

        function _buildPropertyMap() {
          return [{
            name: 'Point of Interest',
            value: Property(element.a, parent)
          }, {
            name: 'Zoom',
            value: Property(element.pe, parent)
          }, {
            name: 'Position',
            value: Property(element.p, parent)
          }, {
            name: 'X Rotation',
            value: Property(element.rx, parent)
          }, {
            name: 'Y Rotation',
            value: Property(element.ry, parent)
          }, {
            name: 'Z Rotation',
            value: Property(element.rz, parent)
          }, {
            name: 'Orientation',
            value: Property(element.or, parent)
          }];
        }

        function getTargetLayer() {
          return state.element;
        }

        var methods = {
          getTargetLayer: getTargetLayer
        };
        return Object.assign(instance, KeyPathNode(state), methods);
      }

      module.exports = Camera;
    }, {
      "../../key_path/KeyPathNode": 12,
      "../../property/Property": 40
    }],
    16: [function (require, module, exports) {
      'use strict';

      var KeyPathList = require('../../key_path/KeyPathList');

      var LayerBase = require('../LayerBase');

      var layer_api = require('../../helpers/layerAPIBuilder');

      var Property = require('../../property/Property');

      var TimeRemap = require('./TimeRemap');

      function Composition(element, parent) {
        var instance = {};
        var state = {
          element: element,
          parent: parent,
          properties: _buildPropertyMap()
        };

        function buildLayerApi(layer, index) {
          var _layerApi = null;
          var ob = {
            name: layer.nm
          };

          function getLayerApi() {
            if (!_layerApi) {
              _layerApi = layer_api(element.elements[index], state);
            }

            return _layerApi;
          }

          Object.defineProperty(ob, 'value', {
            get: getLayerApi
          });
          return ob;
        }

        function _buildPropertyMap() {
          var compositionLayers = element.layers.map(buildLayerApi);
          return [{
            name: 'Time Remap',
            value: TimeRemap(element.tm)
          }].concat(compositionLayers);
        }

        var methods = {};
        return Object.assign(instance, LayerBase(state), KeyPathList(state.elements, 'layer'), methods);
      }

      module.exports = Composition;
    }, {
      "../../helpers/layerAPIBuilder": 6,
      "../../key_path/KeyPathList": 11,
      "../../property/Property": 40,
      "../LayerBase": 13,
      "./TimeRemap": 17
    }],
    17: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../../key_path/KeyPathNode');

      var ValueProperty = require('../../property/ValueProperty');

      function TimeRemap(property, parent) {
        var state = {
          property: property,
          parent: parent
        };
        var _isCallbackAdded = false;
        var currentSegmentInit = 0;
        var currentSegmentEnd = 0;
        var previousTime = 0,
            currentTime = 0;
        var initTime = 0;
        var _loop = true;
        var _loopCount = 0;
        var _speed = 1;
        var _paused = false;
        var _isDebugging = false;
        var queuedSegments = [];

        var _destroyFunction;

        var enterFrameCallback = null;
        var enterFrameEvent = {
          time: -1
        };

        function playSegment(init, end, clear) {
          _paused = false;

          if (clear) {
            clearQueue();
            currentTime = init;
          }

          if (_isDebugging) {
            console.log(init, end);
          }

          _loopCount = 0;
          previousTime = Date.now();
          currentSegmentInit = init;
          currentSegmentEnd = end;
          addCallback();
        }

        function playQueuedSegment() {
          var newSegment = queuedSegments.shift();
          playSegment(newSegment[0], newSegment[1]);
        }

        function queueSegment(init, end) {
          queuedSegments.push([init, end]);
        }

        function clearQueue() {
          queuedSegments.length = 0;
        }

        function _segmentPlayer(currentValue) {
          if (currentSegmentInit === currentSegmentEnd) {
            currentTime = currentSegmentInit;
          } else if (!_paused) {
            var nowTime = Date.now();
            var elapsedTime = _speed * (nowTime - previousTime) / 1000;
            previousTime = nowTime;

            if (currentSegmentInit < currentSegmentEnd) {
              currentTime += elapsedTime;

              if (currentTime > currentSegmentEnd) {
                _loopCount += 1;

                if (queuedSegments.length) {
                  playQueuedSegment();
                } else if (!_loop) {
                  currentTime = currentSegmentEnd;
                } else {
                  /*currentTime -= Math.floor(currentTime / (currentSegmentEnd - currentSegmentInit)) * (currentSegmentEnd - currentSegmentInit);
                  currentTime = currentSegmentInit + currentTime;*/
                  currentTime = currentTime % (currentSegmentEnd - currentSegmentInit); //currentTime = currentSegmentInit + (currentTime);
                  //currentTime = currentSegmentInit + (currentTime - currentSegmentEnd);
                  //console.log('CT: ', currentTime) 
                }
              }
            } else {
              currentTime -= elapsedTime;

              if (currentTime < currentSegmentEnd) {
                _loopCount += 1;

                if (queuedSegments.length) {
                  playQueuedSegment();
                } else if (!_loop) {
                  currentTime = currentSegmentEnd;
                } else {
                  currentTime = currentSegmentInit - (currentSegmentEnd - currentTime);
                }
              }
            }

            if (_isDebugging) {
              console.log(currentTime);
            }
          }

          if (instance.onEnterFrame && enterFrameEvent.time !== currentTime) {
            enterFrameEvent.time = currentTime;
            instance.onEnterFrame(enterFrameEvent);
          }

          return currentTime;
        }

        function addCallback() {
          if (!_isCallbackAdded) {
            _isCallbackAdded = true;
            _destroyFunction = instance.setValue(_segmentPlayer, _isDebugging);
          }
        }

        function playTo(end, clear) {
          _paused = false;

          if (clear) {
            clearQueue();
          }

          addCallback();
          currentSegmentEnd = end;
        }

        function getCurrentTime() {
          if (_isCallbackAdded) {
            return currentTime;
          } else {
            return property.v / property.mult;
          }
        }

        function setLoop(flag) {
          _loop = flag;
        }

        function setSpeed(value) {
          _speed = value;
        }

        function setDebugging(flag) {
          _isDebugging = flag;
        }

        function pause() {
          _paused = true;
        }

        function destroy() {
          if (_destroyFunction) {
            _destroyFunction();

            state.property = null;
            state.parent = null;
          }
        }

        var methods = {
          playSegment: playSegment,
          playTo: playTo,
          queueSegment: queueSegment,
          clearQueue: clearQueue,
          setLoop: setLoop,
          setSpeed: setSpeed,
          pause: pause,
          setDebugging: setDebugging,
          getCurrentTime: getCurrentTime,
          onEnterFrame: null,
          destroy: destroy
        };
        var instance = {};
        return Object.assign(instance, methods, ValueProperty(state), KeyPathNode(state));
      }

      module.exports = TimeRemap;
    }, {
      "../../key_path/KeyPathNode": 12,
      "../../property/ValueProperty": 41
    }],
    18: [function (require, module, exports) {
      'use strict';

      var Property = require('../../property/Property');

      function EffectElement(effect, parent) {
        return Property(effect.p, parent);
      }

      module.exports = EffectElement;
    }, {
      "../../property/Property": 40
    }],
    19: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../../key_path/KeyPathNode');

      var Property = require('../../property/Property');

      var EffectElement = require('./EffectElement');

      function Effects(effects, parent) {
        var state = {
          parent: parent,
          properties: buildProperties()
        };

        function getValue(effectData, index) {
          var nm = effectData.data ? effectData.data.nm : index.toString();
          var effectElement = effectData.data ? Effects(effectData.effectElements, parent) : Property(effectData.p, parent);
          return {
            name: nm,
            value: effectElement
          };
        }

        function buildProperties() {
          var i,
              len = effects.length;
          var arr = [];

          for (i = 0; i < len; i += 1) {
            arr.push(getValue(effects[i], i));
          }

          return arr;
        }

        var methods = {};
        return Object.assign(methods, KeyPathNode(state));
      }

      module.exports = Effects;
    }, {
      "../../key_path/KeyPathNode": 12,
      "../../property/Property": 40,
      "./EffectElement": 18
    }],
    20: [function (require, module, exports) {
      'use strict';

      var LayerBase = require('../LayerBase');

      function Image(element) {
        var state = {
          element: element,
          parent: parent,
          properties: _buildPropertyMap()
        };

        function _buildPropertyMap() {
          return [];
        }

        var methods = {};
        return Object.assign({}, LayerBase(state), methods);
      }

      module.exports = Image;
    }, {
      "../LayerBase": 13
    }],
    21: [function (require, module, exports) {
      'use strict';

      var LayerBase = require('../LayerBase');

      function NullElement(element, parent) {
        var instance = {};
        var state = {
          element: element,
          parent: parent,
          properties: _buildPropertyMap()
        };

        function _buildPropertyMap() {
          return [];
        }

        var methods = {};
        return Object.assign(instance, LayerBase(state), methods);
      }

      module.exports = NullElement;
    }, {
      "../LayerBase": 13
    }],
    22: [function (require, module, exports) {
      'use strict';

      var LayerBase = require('../LayerBase');

      var ShapeContents = require('./ShapeContents');

      function Shape(element, parent) {
        var state = {
          properties: [],
          parent: parent,
          element: element
        };
        var shapeContents = ShapeContents(element.data.shapes, element.itemsData, state);

        function _buildPropertyMap() {
          state.properties.push({
            name: 'Contents',
            value: shapeContents
          });
        }

        var methods = {};

        _buildPropertyMap();

        return Object.assign(state, LayerBase(state), methods);
      }

      module.exports = Shape;
    }, {
      "../LayerBase": 13,
      "./ShapeContents": 23
    }],
    23: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../../key_path/KeyPathNode');

      var Property = require('../../property/Property');

      var ShapeRectangle = require('./ShapeRectangle');

      var ShapeFill = require('./ShapeFill');

      var ShapeStroke = require('./ShapeStroke');

      var ShapeEllipse = require('./ShapeEllipse');

      var ShapeGradientFill = require('./ShapeGradientFill');

      var ShapeGradientStroke = require('./ShapeGradientStroke');

      var ShapeTrimPaths = require('./ShapeTrimPaths');

      var ShapeRepeater = require('./ShapeRepeater');

      var ShapePolystar = require('./ShapePolystar');

      var ShapeRoundCorners = require('./ShapeRoundCorners');

      var ShapePath = require('./ShapePath');

      var Transform = require('../transform/Transform');

      var Matrix = require('../../helpers/transformationMatrix');

      function ShapeContents(shapesData, shapes, parent) {
        var state = {
          properties: _buildPropertyMap(),
          parent: parent
        };
        var cachedShapeProperties = [];

        function buildShapeObject(shape, index) {
          var ob = {
            name: shape.nm
          };
          Object.defineProperty(ob, 'value', {
            get: function get() {
              if (cachedShapeProperties[index]) {
                return cachedShapeProperties[index];
              } else {
                var property;
              }

              if (shape.ty === 'gr') {
                property = ShapeContents(shapesData[index].it, shapes[index].it, state);
              } else if (shape.ty === 'rc') {
                property = ShapeRectangle(shapes[index], state);
              } else if (shape.ty === 'el') {
                property = ShapeEllipse(shapes[index], state);
              } else if (shape.ty === 'fl') {
                property = ShapeFill(shapes[index], state);
              } else if (shape.ty === 'st') {
                property = ShapeStroke(shapes[index], state);
              } else if (shape.ty === 'gf') {
                property = ShapeGradientFill(shapes[index], state);
              } else if (shape.ty === 'gs') {
                property = ShapeGradientStroke(shapes[index], state);
              } else if (shape.ty === 'tm') {
                property = ShapeTrimPaths(shapes[index], state);
              } else if (shape.ty === 'rp') {
                property = ShapeRepeater(shapes[index], state);
              } else if (shape.ty === 'sr') {
                property = ShapePolystar(shapes[index], state);
              } else if (shape.ty === 'rd') {
                property = ShapeRoundCorners(shapes[index], state);
              } else if (shape.ty === 'sh') {
                property = ShapePath(shapes[index], state);
              } else if (shape.ty === 'tr') {
                property = Transform(shapes[index].transform.mProps, state);
              } else {
                console.log(shape.ty);
              }

              cachedShapeProperties[index] = property;
              return property;
            }
          });
          return ob;
        }

        function _buildPropertyMap() {
          return shapesData.map(function (shape, index) {
            return buildShapeObject(shape, index);
          });
        }

        function fromKeypathLayerPoint(point) {
          if (state.hasProperty('Transform')) {
            var toWorldMat = Matrix();
            var transformMat = state.getProperty('Transform').getTargetTransform();
            transformMat.applyToMatrix(toWorldMat);
            point = toWorldMat.applyToPointArray(point[0], point[1], point[2] || 0);
          }

          return state.parent.fromKeypathLayerPoint(point);
        }

        function toKeypathLayerPoint(point) {
          point = state.parent.toKeypathLayerPoint(point);

          if (state.hasProperty('Transform')) {
            var toWorldMat = Matrix();
            var transformMat = state.getProperty('Transform').getTargetTransform();
            transformMat.applyToMatrix(toWorldMat);
            point = toWorldMat.inversePoint(point);
          }

          return point;
        }

        var methods = {
          fromKeypathLayerPoint: fromKeypathLayerPoint,
          toKeypathLayerPoint: toKeypathLayerPoint //state.properties = _buildPropertyMap();

        };
        return Object.assign(state, KeyPathNode(state), methods);
      }

      module.exports = ShapeContents;
    }, {
      "../../helpers/transformationMatrix": 8,
      "../../key_path/KeyPathNode": 12,
      "../../property/Property": 40,
      "../transform/Transform": 39,
      "./ShapeEllipse": 24,
      "./ShapeFill": 25,
      "./ShapeGradientFill": 26,
      "./ShapeGradientStroke": 27,
      "./ShapePath": 28,
      "./ShapePolystar": 29,
      "./ShapeRectangle": 30,
      "./ShapeRepeater": 31,
      "./ShapeRoundCorners": 32,
      "./ShapeStroke": 33,
      "./ShapeTrimPaths": 34
    }],
    24: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../../key_path/KeyPathNode');

      var Property = require('../../property/Property');

      function ShapeEllipse(element, parent) {
        var state = {
          parent: parent,
          properties: _buildPropertyMap()
        };

        function _buildPropertyMap() {
          return [{
            name: 'Size',
            value: Property(element.sh.s, parent)
          }, {
            name: 'Position',
            value: Property(element.sh.p, parent)
          }];
        }

        var methods = {};
        return Object.assign(methods, KeyPathNode(state));
      }

      module.exports = ShapeEllipse;
    }, {
      "../../key_path/KeyPathNode": 12,
      "../../property/Property": 40
    }],
    25: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../../key_path/KeyPathNode');

      var Property = require('../../property/Property');

      function ShapeFill(element, parent) {
        var state = {
          parent: parent,
          properties: _buildPropertyMap()
        };

        function _buildPropertyMap() {
          return [{
            name: 'Color',
            value: Property(element.c, parent)
          }, {
            name: 'Opacity',
            value: {
              setValue: Property(element.o, parent)
            }
          }];
        }

        var methods = {};
        return Object.assign(methods, KeyPathNode(state));
      }

      module.exports = ShapeFill;
    }, {
      "../../key_path/KeyPathNode": 12,
      "../../property/Property": 40
    }],
    26: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../../key_path/KeyPathNode');

      var Property = require('../../property/Property');

      function ShapeGradientFill(element, parent) {
        var state = {
          parent: parent,
          properties: _buildPropertyMap()
        };

        function _buildPropertyMap() {
          return [{
            name: 'Start Point',
            value: Property(element.s, parent)
          }, {
            name: 'End Point',
            value: Property(element.s, parent)
          }, {
            name: 'Opacity',
            value: Property(element.o, parent)
          }, {
            name: 'Highlight Length',
            value: Property(element.h, parent)
          }, {
            name: 'Highlight Angle',
            value: Property(element.a, parent)
          }, {
            name: 'Colors',
            value: Property(element.g.prop, parent)
          }];
        }

        var methods = {};
        return Object.assign(methods, KeyPathNode(state));
      }

      module.exports = ShapeGradientFill;
    }, {
      "../../key_path/KeyPathNode": 12,
      "../../property/Property": 40
    }],
    27: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../../key_path/KeyPathNode');

      var Property = require('../../property/Property');

      function ShapeGradientStroke(element, parent) {
        var state = {
          parent: parent,
          properties: _buildPropertyMap()
        };

        function _buildPropertyMap() {
          return [{
            name: 'Start Point',
            value: Property(element.s, parent)
          }, {
            name: 'End Point',
            value: Property(element.e, parent)
          }, {
            name: 'Opacity',
            value: Property(element.o, parent)
          }, {
            name: 'Highlight Length',
            value: Property(element.h, parent)
          }, {
            name: 'Highlight Angle',
            value: Property(element.a, parent)
          }, {
            name: 'Colors',
            value: Property(element.g.prop, parent)
          }, {
            name: 'Stroke Width',
            value: Property(element.w, parent)
          }];
        }

        var methods = {};
        return Object.assign(methods, KeyPathNode(state));
      }

      module.exports = ShapeGradientStroke;
    }, {
      "../../key_path/KeyPathNode": 12,
      "../../property/Property": 40
    }],
    28: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../../key_path/KeyPathNode');

      var Property = require('../../property/Property');

      function ShapePath(element, parent) {
        var state = {
          parent: parent,
          properties: _buildPropertyMap()
        };

        function setPath(value) {
          Property(element.sh).setValue(value);
        }

        function _buildPropertyMap() {
          return [{
            name: 'path',
            value: Property(element.sh, parent)
          }];
        }

        var methods = {};
        return Object.assign(methods, KeyPathNode(state));
      }

      module.exports = ShapePath;
    }, {
      "../../key_path/KeyPathNode": 12,
      "../../property/Property": 40
    }],
    29: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../../key_path/KeyPathNode');

      var Property = require('../../property/Property');

      function ShapePolystar(element, parent) {
        var state = {
          parent: parent,
          properties: _buildPropertyMap()
        };

        function _buildPropertyMap() {
          return [{
            name: 'Points',
            value: Property(element.sh.pt, parent)
          }, {
            name: 'Position',
            value: Property(element.sh.p, parent)
          }, {
            name: 'Rotation',
            value: Property(element.sh.r, parent)
          }, {
            name: 'Inner Radius',
            value: Property(element.sh.ir, parent)
          }, {
            name: 'Outer Radius',
            value: Property(element.sh.or, parent)
          }, {
            name: 'Inner Roundness',
            value: Property(element.sh.is, parent)
          }, {
            name: 'Outer Roundness',
            value: Property(element.sh.os, parent)
          }];
        }

        var methods = {};
        return Object.assign(methods, KeyPathNode(state));
      }

      module.exports = ShapePolystar;
    }, {
      "../../key_path/KeyPathNode": 12,
      "../../property/Property": 40
    }],
    30: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../../key_path/KeyPathNode');

      var Property = require('../../property/Property');

      function ShapeRectangle(element, parent) {
        var state = {
          parent: parent,
          properties: _buildPropertyMap()
        };

        function _buildPropertyMap() {
          return [{
            name: 'Size',
            value: Property(element.sh.s, parent)
          }, {
            name: 'Position',
            value: Property(element.sh.p, parent)
          }, {
            name: 'Roundness',
            value: Property(element.sh.r, parent)
          }];
        }

        var methods = {};
        return Object.assign(methods, KeyPathNode(state));
      }

      module.exports = ShapeRectangle;
    }, {
      "../../key_path/KeyPathNode": 12,
      "../../property/Property": 40
    }],
    31: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../../key_path/KeyPathNode');

      var Property = require('../../property/Property');

      var Transform = require('../transform/Transform');

      function ShapeRepeater(element, parent) {
        var state = {
          parent: parent,
          properties: _buildPropertyMap()
        };

        function _buildPropertyMap() {
          return [{
            name: 'Copies',
            value: Property(element.c, parent)
          }, {
            name: 'Offset',
            value: Property(element.o, parent)
          }, {
            name: 'Transform',
            value: Transform(element.tr, parent)
          }];
        }

        var methods = {};
        return Object.assign(methods, KeyPathNode(state));
      }

      module.exports = ShapeRepeater;
    }, {
      "../../key_path/KeyPathNode": 12,
      "../../property/Property": 40,
      "../transform/Transform": 39
    }],
    32: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../../key_path/KeyPathNode');

      var Property = require('../../property/Property');

      function ShapeRoundCorners(element, parent) {
        var state = {
          parent: parent,
          properties: _buildPropertyMap()
        };

        function _buildPropertyMap() {
          return [{
            name: 'Radius',
            value: Property(element.rd, parent)
          }];
        }

        var methods = {};
        return Object.assign(methods, KeyPathNode(state));
      }

      module.exports = ShapeRoundCorners;
    }, {
      "../../key_path/KeyPathNode": 12,
      "../../property/Property": 40
    }],
    33: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../../key_path/KeyPathNode');

      var Property = require('../../property/Property');

      function ShapeStroke(element, parent) {
        var state = {
          parent: parent,
          properties: _buildPropertyMap()
        };

        function _buildPropertyMap() {
          return [{
            name: 'Color',
            value: Property(element.c, parent)
          }, {
            name: 'Stroke Width',
            value: Property(element.w, parent)
          }, {
            name: 'Opacity',
            value: Property(element.o, parent)
          }];
        }

        var methods = {};
        return Object.assign(methods, KeyPathNode(state));
      }

      module.exports = ShapeStroke;
    }, {
      "../../key_path/KeyPathNode": 12,
      "../../property/Property": 40
    }],
    34: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../../key_path/KeyPathNode');

      var Property = require('../../property/Property');

      function ShapeTrimPaths(element, parent) {
        var state = {
          parent: parent,
          properties: _buildPropertyMap()
        };

        function _buildPropertyMap() {
          return [{
            name: 'Start',
            value: Property(element.s, parent)
          }, {
            name: 'End',
            value: Property(element.e, parent)
          }, {
            name: 'Offset',
            value: Property(element.o, parent)
          }];
        }

        var methods = {};
        return Object.assign(methods, KeyPathNode(state));
      }

      module.exports = ShapeTrimPaths;
    }, {
      "../../key_path/KeyPathNode": 12,
      "../../property/Property": 40
    }],
    35: [function (require, module, exports) {
      'use strict';

      var LayerBase = require('../LayerBase');

      function Solid(element, parent) {
        var state = {
          element: element,
          parent: parent,
          properties: _buildPropertyMap()
        };

        function _buildPropertyMap() {
          return [];
        }

        var methods = {};
        return Object.assign({}, LayerBase(state), methods);
      }

      module.exports = Solid;
    }, {
      "../LayerBase": 13
    }],
    36: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../../key_path/KeyPathNode');

      var Property = require('../../property/Property');

      var TextAnimator = require('./TextAnimator');

      function Text(element, parent) {
        var instance = {};
        var state = {
          element: element,
          parent: parent,
          properties: _buildPropertyMap()
        };

        function setDocumentData(_function) {
          var previousValue;

          var textDocumentUpdater = function textDocumentUpdater(data) {
            var newValue = _function(element.textProperty.currentData);

            if (previousValue !== newValue) {
              previousValue = newValue;
              return Object.assign({}, data, newValue, {
                __complete: false
              });
            }

            return data;
          };

          element.textProperty.addEffect(textDocumentUpdater);
        }

        function addAnimators() {
          var animatorProperties = [];
          var animators = element.textAnimator._animatorsData;
          var i,
              len = animators.length;
          var textAnimator;

          for (i = 0; i < len; i += 1) {
            textAnimator = TextAnimator(animators[i]);
            animatorProperties.push({
              name: element.textAnimator._textData.a[i].nm || 'Animator ' + (i + 1),
              //Fallback for old animations
              value: textAnimator
            });
          }

          return animatorProperties;
        }

        function _buildPropertyMap() {
          return [{
            name: 'Source',
            value: {
              setValue: setDocumentData
            }
          }].concat(addAnimators());
        }

        var methods = {};
        return Object.assign(instance, methods, KeyPathNode(state));
      }

      module.exports = Text;
    }, {
      "../../key_path/KeyPathNode": 12,
      "../../property/Property": 40,
      "./TextAnimator": 37
    }],
    37: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../../key_path/KeyPathNode');

      var Property = require('../../property/Property');

      function TextAnimator(animator) {
        var instance = {};
        var state = {
          properties: _buildPropertyMap()
        };

        function setAnchorPoint(value) {
          Property(animator.a.a).setValue(value);
        }

        function setFillBrightness(value) {
          Property(animator.a.fb).setValue(value);
        }

        function setFillColor(value) {
          Property(animator.a.fc).setValue(value);
        }

        function setFillHue(value) {
          Property(animator.a.fh).setValue(value);
        }

        function setFillSaturation(value) {
          Property(animator.a.fs).setValue(value);
        }

        function setFillOpacity(value) {
          Property(animator.a.fo).setValue(value);
        }

        function setOpacity(value) {
          Property(animator.a.o).setValue(value);
        }

        function setPosition(value) {
          Property(animator.a.p).setValue(value);
        }

        function setRotation(value) {
          Property(animator.a.r).setValue(value);
        }

        function setRotationX(value) {
          Property(animator.a.rx).setValue(value);
        }

        function setRotationY(value) {
          Property(animator.a.ry).setValue(value);
        }

        function setScale(value) {
          Property(animator.a.s).setValue(value);
        }

        function setSkewAxis(value) {
          Property(animator.a.sa).setValue(value);
        }

        function setStrokeColor(value) {
          Property(animator.a.sc).setValue(value);
        }

        function setSkew(value) {
          Property(animator.a.sk).setValue(value);
        }

        function setStrokeOpacity(value) {
          Property(animator.a.so).setValue(value);
        }

        function setStrokeWidth(value) {
          Property(animator.a.sw).setValue(value);
        }

        function setStrokeBrightness(value) {
          Property(animator.a.sb).setValue(value);
        }

        function setStrokeHue(value) {
          Property(animator.a.sh).setValue(value);
        }

        function setStrokeSaturation(value) {
          Property(animator.a.ss).setValue(value);
        }

        function setTrackingAmount(value) {
          Property(animator.a.t).setValue(value);
        }

        function _buildPropertyMap() {
          return [{
            name: 'Anchor Point',
            value: {
              setValue: setAnchorPoint
            }
          }, {
            name: 'Fill Brightness',
            value: {
              setValue: setFillBrightness
            }
          }, {
            name: 'Fill Color',
            value: {
              setValue: setFillColor
            }
          }, {
            name: 'Fill Hue',
            value: {
              setValue: setFillHue
            }
          }, {
            name: 'Fill Saturation',
            value: {
              setValue: setFillSaturation
            }
          }, {
            name: 'Fill Opacity',
            value: {
              setValue: setFillOpacity
            }
          }, {
            name: 'Opacity',
            value: {
              setValue: setOpacity
            }
          }, {
            name: 'Position',
            value: {
              setValue: setPosition
            }
          }, {
            name: 'Rotation X',
            value: {
              setValue: setRotationX
            }
          }, {
            name: 'Rotation Y',
            value: {
              setValue: setRotationY
            }
          }, {
            name: 'Scale',
            value: {
              setValue: setScale
            }
          }, {
            name: 'Skew Axis',
            value: {
              setValue: setSkewAxis
            }
          }, {
            name: 'Stroke Color',
            value: {
              setValue: setStrokeColor
            }
          }, {
            name: 'Skew',
            value: {
              setValue: setSkew
            }
          }, {
            name: 'Stroke Width',
            value: {
              setValue: setStrokeWidth
            }
          }, {
            name: 'Tracking Amount',
            value: {
              setValue: setTrackingAmount
            }
          }, {
            name: 'Stroke Opacity',
            value: {
              setValue: setStrokeOpacity
            }
          }, {
            name: 'Stroke Brightness',
            value: {
              setValue: setStrokeBrightness
            }
          }, {
            name: 'Stroke Saturation',
            value: {
              setValue: setStrokeSaturation
            }
          }, {
            name: 'Stroke Hue',
            value: {
              setValue: setStrokeHue
            }
          }];
        }

        var methods = {};
        return Object.assign(instance, methods, KeyPathNode(state));
      }

      module.exports = TextAnimator;
    }, {
      "../../key_path/KeyPathNode": 12,
      "../../property/Property": 40
    }],
    38: [function (require, module, exports) {
      'use strict';

      var LayerBase = require('../LayerBase');

      var Text = require('./Text');

      function TextElement(element) {
        var instance = {};
        var TextProperty = Text(element);
        var state = {
          element: element,
          properties: _buildPropertyMap()
        };

        function _buildPropertyMap() {
          return [{
            name: 'text',
            value: TextProperty
          }, {
            name: 'Text',
            value: TextProperty
          }];
        }

        function getText() {
          return element.textProperty.currentData.t;
        }

        function setText(value, index) {
          setDocumentData({
            t: value
          }, index);
        }

        function setDocumentData(data, index) {
          return element.updateDocumentData(data, index);
        }

        function canResizeFont(_canResize) {
          return element.canResizeFont(_canResize);
        }

        function setMinimumFontSize(_fontSize) {
          return element.setMinimumFontSize(_fontSize);
        }

        var methods = {
          getText: getText,
          setText: setText,
          canResizeFont: canResizeFont,
          setDocumentData: setDocumentData,
          setMinimumFontSize: setMinimumFontSize
        };
        return Object.assign(instance, LayerBase(state), methods);
      }

      module.exports = TextElement;
    }, {
      "../LayerBase": 13,
      "./Text": 36
    }],
    39: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../../key_path/KeyPathNode');

      var Property = require('../../property/Property');

      function Transform(props, parent) {
        var state = {
          properties: _buildPropertyMap()
        };

        function _buildPropertyMap() {
          return [{
            name: 'Anchor Point',
            value: Property(props.a, parent)
          }, {
            name: 'Point of Interest',
            value: Property(props.a, parent)
          }, {
            name: 'Position',
            value: Property(props.p, parent)
          }, {
            name: 'Scale',
            value: Property(props.s, parent)
          }, {
            name: 'Rotation',
            value: Property(props.r, parent)
          }, {
            name: 'X Position',
            value: Property(props.px, parent)
          }, {
            name: 'Y Position',
            value: Property(props.py, parent)
          }, {
            name: 'Z Position',
            value: Property(props.pz, parent)
          }, {
            name: 'X Rotation',
            value: Property(props.rx, parent)
          }, {
            name: 'Y Rotation',
            value: Property(props.ry, parent)
          }, {
            name: 'Z Rotation',
            value: Property(props.rz, parent)
          }, {
            name: 'Opacity',
            value: Property(props.o, parent)
          }];
        }

        function getTargetTransform() {
          return props;
        }

        var methods = {
          getTargetTransform: getTargetTransform
        };
        return Object.assign(methods, KeyPathNode(state));
      }

      module.exports = Transform;
    }, {
      "../../key_path/KeyPathNode": 12,
      "../../property/Property": 40
    }],
    40: [function (require, module, exports) {
      'use strict';

      var KeyPathNode = require('../key_path/KeyPathNode');

      var ValueProperty = require('./ValueProperty');

      function Property(property, parent) {
        var state = {
          property: property,
          parent: parent
        };

        function destroy() {
          state.property = null;
          state.parent = null;
        }

        var methods = {
          destroy: destroy
        };
        return Object.assign({}, methods, ValueProperty(state), KeyPathNode(state));
      }

      module.exports = Property;
    }, {
      "../key_path/KeyPathNode": 12,
      "./ValueProperty": 41
    }],
    41: [function (require, module, exports) {
      'use strict';

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      function ValueProperty(state) {
        function setValue(value) {
          var property = state.property;

          if (!property || !property.addEffect) {
            return;
          }

          if (typeof value === 'function') {
            return property.addEffect(value);
          } else if (property.propType === 'multidimensional' && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.length === 2) {
            return property.addEffect(function () {
              return value;
            });
          } else if (property.propType === 'unidimensional' && typeof value === 'number') {
            return property.addEffect(function () {
              return value;
            });
          }
        }

        function getValue() {
          return state.property.v;
        }

        var methods = {
          setValue: setValue,
          getValue: getValue
        };
        return methods;
      }

      module.exports = ValueProperty;
    }, {}],
    42: [function (require, module, exports) {
      'use strict';

      var LayerList = require('../layer/LayerList');

      var KeyPathList = require('../key_path/KeyPathList');

      function Renderer(state) {
        state._type = 'renderer';

        function getRendererType() {
          return state.animation.animType;
        }

        return Object.assign({
          getRendererType: getRendererType
        }, LayerList(state.elements), KeyPathList(state.elements, 'renderer'));
      }

      module.exports = Renderer;
    }, {
      "../key_path/KeyPathList": 11,
      "../layer/LayerList": 14
    }]
  }, {}, [10])(10);
});